import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Contexts from 'contexts';
import MantineDateProviders from 'providers/MantineDateProviders';
import { MsalProvider } from 'providers/MsalProviders';

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <Contexts>
      <MantineDateProviders>
        <MsalProvider>
          <App />
        </MsalProvider>
      </MantineDateProviders>
    </Contexts>
  </React.StrictMode>
);

reportWebVitals();
